import { render } from "./AccessRequests.vue?vue&type=template&id=2c8c8353&scoped=true"
import script from "./AccessRequests.vue?vue&type=script&lang=js"
export * from "./AccessRequests.vue?vue&type=script&lang=js"

import "./AccessRequests.vue?vue&type=style&index=0&id=2c8c8353&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c8c8353"]])

export default __exports__